import { useGetCurrentEmployeeQuery } from "@/store/employee/endpoints";

const useCurrentUserHook = () => {
  const { data: currentEmployee, isLoading } = useGetCurrentEmployeeQuery(undefined, {
    skip: location.pathname.includes("logout-session"),
  });

  if (isLoading)
    return {
      isLoadingUser: isLoading,
      openUserModal: false,
    };

  const hasEnterpriseRecords =
    (currentEmployee?.enterpriseRecords?.length === 0 &&
      (currentEmployee?.enterprises ?? []).length > 0 &&
      !currentEmployee?.enterprises?.some(enterprise => enterprise.title === "Company Name")) ||
    (currentEmployee?.enterpriseRecords ?? []).length > 0;
  const hasActivityDomain = currentEmployee?.activityDomain;
  const hasSubActivityDomain = (currentEmployee?.subActivityDomains ?? []).length > 0;
  const hasJobTitle = currentEmployee?.jobTitle;
  const hasValidPhoneNumber = currentEmployee?.phone1Valid;

  // NOTE: specialities intentionally NOT part of the gate anymore. The signup
  // wizard (websitedev /register) collects metier + activites but not
  // specialities, and re-opening the whole onboarding for that one optional
  // field punished every funnel-registered user. Specialities stay editable
  // from the profile pages.
  const openUserModal = Boolean(
    !(
      hasEnterpriseRecords &&
      hasActivityDomain &&
      hasSubActivityDomain &&
      hasJobTitle &&
      hasValidPhoneNumber
    )
  );
  return { openUserModal };
};

export default useCurrentUserHook;
